import { INITIALIZE_FORM } from '../actionTypes';
import { profileConfigurationActions } from '../reducer';

export default (values) => profileConfigurationActions[INITIALIZE_FORM](values);
